import localSave from '@utils/local-save'

export const RECENT_KEYWORDS_KEY = 'recentSearchKeywords'
const MAX_ITEMS = 5

// Submitted keywords for the typeahead's empty state (D7). Distinct from
// recent-search-service.js, which remembers VISITED entities for the Search landing.
function read(): string[] {
    const stored = localSave.get<unknown>(RECENT_KEYWORDS_KEY)
    return Array.isArray(stored) ? stored.filter((item): item is string => typeof item === 'string') : []
}

function write(items: string[]): void {
    localSave.save(RECENT_KEYWORDS_KEY, items)
}

export default {
    getRecent(): string[] {
        return read()
    },

    add(keyword: string): string[] {
        const trimmed = (keyword || '').trim()
        if (!trimmed) return read()
        const lower = trimmed.toLowerCase()
        const items = [trimmed, ...read().filter(item => item.toLowerCase() !== lower)].slice(0, MAX_ITEMS)
        write(items)
        return items
    },

    remove(keyword: string): string[] {
        const lower = (keyword || '').trim().toLowerCase()
        const items = read().filter(item => item.toLowerCase() !== lower)
        write(items)
        return items
    },

    clear(): void {
        write([])
    },
}
